// tracing.js
// Add this import at the top of the file
import 'zone.js';

import { diag, DiagConsoleLogger, DiagLogLevel } from '@opentelemetry/api';
import { WebTracerProvider } from '@opentelemetry/sdk-trace-web';
import { ZoneContextManager } from '@opentelemetry/context-zone-peer-dep';
import { W3CTraceContextPropagator } from '@opentelemetry/core';
import { registerInstrumentations } from '@opentelemetry/instrumentation';
import { XMLHttpRequestInstrumentation } from '@opentelemetry/instrumentation-xml-http-request';

// Optional: enable OTEL internal diagnostics during local development
diag.setLogger(new DiagConsoleLogger(), DiagLogLevel.ERROR);

const provider = new WebTracerProvider({
  // You can set resource attributes here (e.g., service.name)
  // resource: new Resource({ ['service.name']: 'repoweb-react' }),
});

// For dev, see spans in console. In prod, you typically export to an OTEL collector endpoint via OTLP exporter.
// provider.addSpanProcessor(new SimpleSpanProcessor(new ConsoleSpanExporter()));
provider.register({
  contextManager: new ZoneContextManager().enable(),
  propagator: new W3CTraceContextPropagator(),
});

// Optional auto-instrumentation for XHR (if you also use fetch/XHR directly).
// We'll still do manual Axios injection below; this helps if any libs use XHR under the hood.
registerInstrumentations({
  instrumentations: [
    new XMLHttpRequestInstrumentation({
      propagateTraceHeaderCorsUrls: [/.*/],
      clearTimingResources: true,
    }),
  ],
});

export function getTracer() {
  // A name for your frontend app
  return provider.getTracer('repoweb-react', '1.0.0');
}
